// Core Imports
import styled from "styled-components";

// MUI
import { Alert } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { styled as muiStyle } from "@mui/material/styles";

// Loading component
const LoadingMessage = ({message}) => {
    return (
        <Center>
            <StyledAlert severity="info">
                {message}
            </StyledAlert>
            <CircularProgress />
        </Center>
    )
}

const Center = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const StyledAlert = muiStyle(Alert)({
    display: "flex",
    alignItems: "center",
    margin: "25px",
    fontSize: "22px",
})

export default LoadingMessage